import { WebPlugin } from '@capacitor/core';
export class PrinterWeb extends WebPlugin {
    async initialize() {
        console.warn('Printer is not available on web');
        return { status: 'web-not-available' };
    }
    async printText() {
        console.warn('printText not available on web');
    }
    async printBarcode() {
        console.warn('printBarcode not available on web');
    }
    async printQr() {
        console.warn('printQr not available on web');
    }
    async printImage() {
        console.warn('printImage not available on web');
    }
}
//# sourceMappingURL=web.js.map